import { IActiveTicketsByExpedition, IPublicTicket, ISuggestion } from '../../models'
import { BaseHttpService } from './base'

type IIdentifier = number | string | null | undefined

const uniqueIdentifiers = (identifiers: IIdentifier[]): string =>
  Array.from(new Set(identifiers.filter((identifier) => identifier !== null && identifier !== undefined && identifier !== '')))
    .join(',')

class SuggestionService extends BaseHttpService {
  public addSuggestion = async (suggestion: ISuggestion): Promise<any> => {
    return this.post('suggestions', suggestion)
  }

  public getActiveTicketsByExpeditions = async (expeditionIds: IIdentifier[]): Promise<IActiveTicketsByExpedition> => {
    const expeditions = uniqueIdentifiers(expeditionIds)
    if (!expeditions) return {}
    try {
      return await this.get(`suggestions/active?expeditions=${ expeditions }`)
    } catch (error) {
      return {}
    }
  }

  public getMapActiveTickets = async (serviceInfoIds: IIdentifier[]): Promise<IPublicTicket[]> => {
    const serviceInfos = uniqueIdentifiers(serviceInfoIds)
    if (!serviceInfos) return []
    try {
      return await this.get(`suggestions/active/map?serviceInfos=${ serviceInfos }`)
    } catch (error) {
      return []
    }
  }
}

export default new SuggestionService()
